import { createRouter, createWebHistory } from 'vue-router';
import Leads from '../views/Leads.vue';
import FindContractor from '../views/FindContractor.vue';
import Admin from '../views/Admin.vue';
import UserProfile from '../views/UserProfile.vue';
import useSaveProtect from '../composables/useSaveProtect';
import useCurrentUser from '@/composables/useCurrentUser';
import CustomerReport from '../views/reports/CustomerReport.vue';
import SalesImpactReport from '../views/reports/SalesImpactReport.vue';
import CompanyReport from '../views/reports/CompanyReport.vue';
import Contacts from '../views/Contacts.vue';
import PageNotFound from '../views/fallbacks/PageNotFound.vue';
import Unauthorized from '../views/fallbacks/Unauthorized.vue';
import { watch } from 'vue';

const { user } = useCurrentUser();
const { state } = useSaveProtect();

const routes = [
  {
    path: '/',
    name: 'page-not-found',
    component: PageNotFound,
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: Unauthorized,
  },
  {
    path: '/leads',
    name: 'leads',
    component: Leads,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/companies/:companyid?',
    name: 'companies',
    component: Contacts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contacts/:contactid?',
    query: {
      linkedCompanyId: null,
      linkedCompanyName: null,
    },
    name: 'contacts',
    component: Contacts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/customer-report',
    name: 'customer-report',
    component: CustomerReport,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/company-report',
    name: 'company-report',
    component: CompanyReport,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/find-contractor',
    name: 'find-contractor',
    component: FindContractor,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sales-impact-report',
    name: 'sales-impact-report',
    component: SalesImpactReport,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin',
    name: 'admin',
    redirect: { name: 'admin-options' },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: Admin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/options',
    name: 'admin-options',
    component: Admin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/logs',
    name: 'admin-logs',
    component: Admin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/assign-salesperson',
    name: 'admin-assign-salesperson',
    component: Admin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user-profile',
    name: 'user-profile',
    component: UserProfile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'page-not-found',
    component: PageNotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function checkPermissions(routeName) {
  if (routeName == 'sales-impact-report' && !user.showImpactReport) {
    return false;
  } else if (routeName == 'admin-options' && !user.admin && !user.contactsAdmin) {
    return false;
  } else if (routeName == 'admin-users' && !user.admin) {
    return false;
  } else if (routeName == 'admin-logs' && !user.admin && !user.contactsAdmin) {
    return false;
  } else if (routeName == 'admin-assign-salesperson' && !user.admin && !user.contactsAdmin) {
    return false;
  } else if (routeName == 'customer-report' && !user.showGeneralReports) {
    return false;
  } else if (routeName == 'company-report' && !user.showGeneralReports) {
    return false;
  } else if (routeName == 'leads' && !user.showLeads) {
    return false;
  } else if (routeName == 'companies' && !user.showContacts) {
    return false;
  } else if (routeName == 'contacts' && !user.showContacts) {
    return false;
  }

  return true;
}

watch(
  user,
  (newVal) => {
    if (newVal.userid) {
      if (!checkPermissions(router.currentRoute.value.name)) {
        router.push({ name: 'unauthorized' });
      }
    }
  },
  { deep: true }
);

router.beforeEach(async (to, from) => {
  if (!checkPermissions(to.name) && user.userid) {
    return router.push({ name: 'unauthorized' });
  }

  if (state.isDirty) {
    state.showConfirm = true;
    state.toNext = to.name;
    state.toNextParams = to.params;
    return false;
  }
});

export default router;
